<template>
  <div class="pic_bg">
    <div>
      <header>
        <el-image :src="iconHeader"></el-image>
        <span class="title_font" @click="goBack()">{{ titleName }}</span>
      </header>
      <div class="title_line"></div>
      <body>
        <div v-if="isShowList && caseInfo.infoList.length">
          <div class="list_bg">
            <div
              class="video_bg t-h"
              v-for="(item, index) in caseInfo.infoList"
              :key="index"
              @click="checkItem(item)"
            >
              <el-image :src="item.cfFmimg" class="video_bg_one">
                <div slot="error">
                  <el-image :src="defaultImg"> </el-image>
                </div>
              </el-image>
              <p>{{ item.cfTitle }}</p>
              <div class="line_two"></div>
            </div>
          </div>
          <div style="text-align: center; margin-top: 8px">
            <el-pagination
              @current-change="handleCurrentChange"
              :page-size="pageParams.pageSize"
              layout="prev, pager, next"
              :total="caseInfo.total"
            >
            </el-pagination>
          </div>
        </div>
        <div v-else>
          <div style="font-size:18px;margin:20px 0;text-indent:44px;">敬请期待...</div>
        </div>
        <div class="ql-editor" v-show="isShowContent" v-html="htmlInfo"></div>
      </body>
    </div>
  </div>
</template>

<script>
import { getCaseofillList, setBrowerecord } from "@/network/api";

export default {
  data() {
    return {
      defaultImg: require("@/assets/images/defalut_icon.png"),
      iconHeader: require("@/assets/images/pageico_6.png"),
      isShowContent: false,
      isShowList: true,
      htmlInfo: "",
      titleName: "病例中心",
      caseInfo: {
        infoList: [],
        total: 0,
      },
      pageParams: {
        pageNum: 1,
        pageSize: 10,
      },
    };
  },
  mounted() {
    this.initData();
  },
  methods: {
    checkItem(item) {
      setBrowerecord('caseofill', item.id)
      this.htmlInfo = item.cfContent;
      this.isShowContent = true;
      this.isShowList = false;
      this.titleName = "病例中心 | " + item.cfTitle + " |【返回】";
    },
    goBack() {
      this.isShowContent = false;
      this.isShowList = true;
      this.titleName = "病例中心";
    },
    initData: function () {
      getCaseofillList(this.pageParams).then((res) => {
        this.caseInfo.infoList = res.rows;
        this.caseInfo.total = res.total;
      });
    },
    handleCurrentChange(val) {
      this.pageParams.pageNum = val;
      this.initData();
    },
  },
};
</script>


<style scoped>
.pic_bg {
  display: flex;
  justify-content: center;
}
header {
  width: 1150px;
  display: flex;
  margin-bottom: 6px;
  align-items: center;
}
body {
  width: 1150px;
  margin-top: 12px;
  margin-bottom: 12px;
}
.list_bg {
  display: flex;
  flex-wrap: wrap;
}
.video_bg {
  margin-left: 12px;
}
.video_bg p {
  text-align: center;
  font-size: 16px;
  color: #353535;
  font-weight: bold;
}
p {
  text-align: left;
  text-indent: 24px;
  font-size: 16px;
  color: #787878;
  line-height: 24px;
}
.line_two {
  border-bottom: 1px dashed #e2e2e2;
  margin-top: 6px;
}
.video_bg_one {
  width: 356px;
  height: 253px;
}
.title_line {
  padding: 0;
  height: 1px;
  background-color: #b7b7b7;
}
.title_font {
  color: #397b3e;
  font-size: 20px;
  margin-left: 6px;
  cursor: pointer;
}
.t-h:hover {
  color: #397b3e;
  cursor: pointer;
}
.t-h:hover p {
  color: #397b3e;
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/CaseCenter.vue